import { render, staticRenderFns } from "./Issue.vue?vue&type=template&id=36c1b775&scoped=true&"
import script from "./Issue.vue?vue&type=script&lang=ts&"
export * from "./Issue.vue?vue&type=script&lang=ts&"
import style0 from "./Issue.vue?vue&type=style&index=0&id=36c1b775&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c1b775",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36c1b775')) {
      api.createRecord('36c1b775', component.options)
    } else {
      api.reload('36c1b775', component.options)
    }
    module.hot.accept("./Issue.vue?vue&type=template&id=36c1b775&scoped=true&", function () {
      api.rerender('36c1b775', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/issues/Issue.vue"
export default component.exports